import { lazy } from 'react';

export const Home = lazy(() => import(/* webpackChunkName: "Home" */ 'pages/Home'));
export const PdfViewer = lazy(() => import(/* webpackChunkName: "PdfViewer" */ 'pages/PdfViewer'));
